__webpack_require__.p = "/typo3conf/ext/dl_naturata/";